var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextAlignLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 0H0V1.6H14.4V0Z",
    fill: "#0077B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 3.20001H0V4.80001H11.2V3.20001Z",
    fill: "#0077B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.40002H0V8.00002H16V6.40002Z",
    fill: "#0077B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 9.59998H0V11.2H11.2V9.59998Z",
    fill: "#0077B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 12.8H0V14.4H14.4V12.8Z",
    fill: "#0077B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextAlignLeft);
export default __webpack_public_path__ + "static/media/text-align-left.ba37217affd8fb5fbd7ae66772d49834.svg";
export { ForwardRef as ReactComponent };